export default "__VITE_ASSET__CYkPNnCO__"